import axiosInstance from "../../../utils/axios";


const path = "/waiter/order";

const authPath = "/waiter/auth"



export const createOrder = async (values , option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/save`, values);
}

export const generateToken = async (values) => {
  return await axiosInstance().post(`${authPath}/QR-CODE/token`, values);
}

export const lineVerify = async (values, option = {}) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: option.token
      ? { authorization: `Bearer ${option.token}`, "x-bypass-origin":"true" }
      : {},
  }).post(`${authPath}/line/verify`, values);
}

export const lineStatus = async (values, option = {}) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: option.token
      ? { authorization: `Bearer ${option.token}`, "x-bypass-origin":"true" }
      : {},
  }).post(`${authPath}/line/status`, values);
}

export const detail = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).get(`${path}/details?o_id=${values.o_id}`, values);
}

export const checkoutOrder = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).get(`${path}/checkout?o_id=${values.o_id}`, values);
}







